import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { PagedResponse, Role, RoleStatus, RoleUpsert } from '../types'

const BASE = '/management/roles'

/** Silinmemiş roller (yönetim ölçeği küçük → tek sayfada size=200). */
export async function getRoles(): Promise<PagedResponse<Role>> {
  const { data } = await apiClient.get<PagedResponse<Role>>(BASE, { params: { page: 0, size: 200 } })
  return data
}

export async function createRole(body: RoleUpsert): Promise<Role> {
  const { data } = await apiClient.post<Role>(BASE, body)
  return data
}

export async function updateRole(id: number, body: RoleUpsert): Promise<Role> {
  const { data } = await apiClient.put<Role>(`${BASE}/${id}`, body)
  return data
}

export async function changeRoleStatus(id: number, body: RoleStatus): Promise<Role> {
  const { data } = await apiClient.put<Role>(`${BASE}/${id}/status`, body)
  return data
}

export async function deleteRole(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/** Role atanmış (aktif) yetki id'leri. */
export async function getRoleGrants(id: number): Promise<number[]> {
  const { data } = await apiClient.get<number[]>(`${BASE}/${id}/grants`)
  return data
}

/** Rolün yetki kümesini ayarla (set semantiği). */
export async function setRoleGrants(id: number, grantIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/${id}/grants`, { grantIds })
}

/**
 * Rol listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 *
 * `grantId`: ekrandaki yetki filtresi — yalnız o yetkinin verildiği roller dosyaya girer.
 */
export async function exportRoles(grantId?: number): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { grantId }, 'roller.xlsx')
}
